
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homes",
      function () {
        return require("private-next-pages/homes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homes"])
      });
    }
  